export default __webpack_public_path__ + "static/s_00-2063cd19e9f3ecc8776e4ae97327d2d8.png";